import { useQuery } from "@tanstack/react-query";
import axios from "../../../services/axios/config";
import {
  useSelectManualSearchEnabled,
  useSelectManualSearchFilters,
  useSelectManualSearchSearchId,
} from "../../../redux/features/manualSearch/manualSearchSlice";

async function getManualSearchData({ searchId, filters, page, take }) {
  const res = await axios.post(
    `/search/base?id=${searchId}&page=${page}&size=${take}`,
    filters,
  );

  return {
    data:
      res.data?.columnData?.map((row) => ({
        ...row.data,
        flagId: row.flagId,
      })) || [],
    totalCount: res.data?.totalCount || 0,
  };
}

export function useManualSearchTableQuery({ page, take }) {
  const enabled = useSelectManualSearchEnabled();
  const searchId = useSelectManualSearchSearchId();
  const filters = useSelectManualSearchFilters();

  return useQuery({
    queryKey: ["manual-search", "table", searchId, filters, page, take],
    queryFn: () => getManualSearchData({ searchId, filters, page, take }),
    enabled: Boolean(enabled && searchId),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
